import PropTypes from 'prop-types';
import React from 'react';

export default function FootballComparativeNumericStats(props) {
  require("./FootballComparativeNumericStats.scss");

  const {
    title,
    bigNumber,
    smallNumber
  } = props;

  return (
    <div className="comparativeNumericStats">
      <div className="live-score-emphasize">
        <div className="live-score-title">{title}</div>
      </div>
      <div className="live-score-big-number">
        <div className="big-number">{bigNumber}</div>
      </div>
      <div className="live-score-small-number">
        <div className="small-number">{smallNumber}</div>
      </div>
    </div>
  )
}

FootballComparativeNumericStats.propTypes = {
  title: PropTypes.string.isRequired,
  bigNumber: PropTypes.number.isRequired,
  smallNumber: PropTypes.number.isRequired
};



// WEBPACK FOOTER //
// ./modules/Football/components/FootballComparativeNumericStats.js